// import React, { useEffect } from 'react';
import MonthButtons from './month-buttons'


function Header({handleYearChange, currentMonth, currentYear, monthUserEvents, selectedMonth, changeSelectedMonth}) {


  return (
    <MonthButtons handleYearChange={handleYearChange} currentYear={currentYear} currentMonth={currentMonth} changeSelectedMonth={changeSelectedMonth} monthUserEvents={monthUserEvents} selectedMonth={selectedMonth} />
  )
}

export default Header;
